<div class="modal-header">
    <h4 class="modal-title">{{(item?.Id ? 'edit' : 'add') | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="col form-field required">
            <label class="form-label">{{'messages_code' | translate}}</label>
            <input class="form-control" required name="CodeInput" [(ngModel)]="item.Code" />
        </div>

        <div class="form-field required">
            <label class="form-label">{{'messages_coltitle' | translate}}</label>
            <input class="form-control" required name="TitleInput" [(ngModel)]="item.Title" />
        </div>

        <div class="row">
            <div class="col form-field required">
                <label class="form-label">{{'messages_colgroup' | translate}}</label>
                <input class="form-control" required name="GroupInput" [(ngModel)]="item.Group" />
            </div>

            <div class="col form-field">
                <label class="form-label">{{'messages_colUserRights' | translate}}</label>
                <app-select [(ngModel)]="item.UserRights"
                            [options]="userRights"
                            [valueProperty]="'Code'"
                            [displayProperty]="'Text'"
                            name="userRights"></app-select>
            </div>
        </div>

        <div class="form-field">
            <label class="form-label">{{'messages_colTextLv' | translate}}</label>
            <editor *ngIf="isRichEditor()" [(ngModel)]="item.TextLV" name="TextLVInput" [init]="editorConfig"></editor>
            <textarea *ngIf="!isRichEditor()" class="form-control" [(ngModel)]="item.TextLV" name="TextLVInput" rows="10"></textarea>
        </div>

        <div class="form-field">
            <label class="form-label">{{'messages_colTextEn' | translate}}</label>
            <editor *ngIf="isRichEditor()" [(ngModel)]="item.TextEN" name="TextENInput" [init]="editorConfig"></editor>
            <textarea *ngIf="!isRichEditor()" class="form-control" [(ngModel)]="item.TextEN" name="TextENInput" rows="10"></textarea>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()" [disabled]="isSaving">{{'cancel' | translate}}</button>

    <button class="btn btn-primary" (click)="save()" type="button" [disabled]="isSaving">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isSaving"></span>
        {{'save' | translate}}
    </button>
</div>
